








































































































































import {
  apiSubscribeCommodityArrivalReminderAdd,
  apiSubscribeCommodityArrivalReminderStatus,
} from '@/api'
import {
  computed,
  onMounted,
  onUpdated,
  ref,
  watch,
} from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { navigateTo, redirectTo } from '@/router'
import { submit } from '@/utils'
import { useQuery } from '@/hooks'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        onMounted(() => {
          this.updateHeight()
        })

        onUpdated(() => {
          this.updateHeight()
        })
        watch(
          () => this.isSold.value,
          () => {
            if (this.isSold.value) {
              this.getcommodityArrivalReminderStatus()
            }
          },
          { immediate: true },
        )
      }

      query = useQuery<{
        goodsId: string
        id: string
        tradeId: string
      }>()

      // 商品数据
      goodsData = goodsProvider.inject()

      // 店铺是否休息
      isRest = computed(() => this.goodsData.value.storeStatus === 4)

      // 是否卖光
      isSold = computed(() => this.goodsData.value.isSold)

      // 购物车商品数量
      cartCount = ref(0)

      // 是否添加商品到货提醒状态
      isAddCommodityArrivalReminder = ref(false)

      // 操作栏高度
      height = ref(0)

      // 更新高度
      updateHeight = () => {
        this.height.value =
          (document.querySelector(`.${ctx._.actions}`)?.clientHeight || 0) +
          (document.querySelector(`.${ctx._.tips}`)?.clientHeight || 0)
      }

      // 点击店铺
      handleMartClick = () => {
        navigateTo('MartIndex', {
          id: this.goodsData.value.merchantId,
        })
      }

      // 点击收藏
      handleFavoriteClick = () => {
        this.goodsData.value.favorite()
        // TODO: 需后端提供批量查询
        // this.goodsData.skuPicker = {
        //   visible: true,
        //   action: 'favorite',
        // }
      }

      // 点击购物车
      handleCartClick = () => {
        navigateTo('CartIndex')
      }

      // 点击到货提醒
      handleNoticeClick = () => {
        submit(async $ => {
          $.start()
          await apiSubscribeCommodityArrivalReminderAdd({
            commodityId: this.goodsData.value.commodityId,
            skuId: this.goodsData.value.selectedSku.skuId,
          })
          this.isAddCommodityArrivalReminder.value = true
          await $.success('已添加到货提醒')
        })
      }

      // 获取到货提醒
      getcommodityArrivalReminderStatus = async () => {
        const { status } = await apiSubscribeCommodityArrivalReminderStatus({
          commodityId: this.goodsData.value.commodityId,
          skuId: this.goodsData.value.selectedSku.skuId,
        })

        this.isAddCommodityArrivalReminder.value = !!status
      }

      // 点击购买
      handleBuyClick = async () => {
        submit(async () => {
          // 弹窗进行了路由改造，直接 redirect 过去即可
          redirectTo('OrderPlace1', {
            id: this.goodsData.value.commodityId,
            tradeId: this.query.tradeId,
          })
        })
      }
    },
)
